import { render } from "./PackageDetails.vue?vue&type=template&id=58e0cd55&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"

import "./PackageDetails.vue?vue&type=style&index=0&id=58e0cd55&lang=scss&scoped=true"
import "./PackageDetails.vue?vue&type=style&index=1&id=58e0cd55&lang=scss"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e0cd55"]])

export default __exports__